import axios from "axios";
import {
  EDOS_LIST,
  DISEASE_NAME,
  SAMPLE_TYPE,
  FILTERED_LIST,
  GET_ALL_CITIES,
  ALL_DISEASE_LIST,
  ALL_SAMPLE_LIST,
} from "../Endpoints/endpoint";

// GETTING EDOS_LIST FROM API.....

export const EdosList = async () => {
  return await axios.get(process.env.REACT_APP_API_PATH + EDOS_LIST);
};

// GETTING DISEASE_NAME FROM API....

export const DiseaseName = async () => {
  return await axios.get(process.env.REACT_APP_API_PATH + ALL_DISEASE_LIST);
};

// export const DiseaseName = async (sampleId) => {
//   return await axios.post(process.env.REACT_APP_API_PATH + DISEASE_NAME, sampleId);
// };

// GETTING SAMPLE_TYPE FROM API....

export const SampleTypeList = async () => {
  return await axios.get(process.env.REACT_APP_API_PATH + ALL_SAMPLE_LIST);
};

// export const SampleTypeList = async (ids) => {
//   return await axios.post(process.env.REACT_APP_API_PATH + SAMPLE_TYPE, ids);
// };

// GETTING SAMPLE_TYPE FROM API....

export const FilteredList = async (data) => {
  return await axios.post(process.env.REACT_APP_API_PATH + FILTERED_LIST, data);
};

export const getAllCities = async () => {
  return await axios.get(process.env.REACT_APP_API_PATH + GET_ALL_CITIES);
};
